<div class="flex justify-between content-center">
  <div class="flex flex-col">
    <h3 mat-dialog-title>Single expert view</h3>
  </div>

  <button mat-icon-button mat-dialog-close>
    <mat-icon>clear</mat-icon>
  </button>
</div>

<div class="view-respondent-subtitle flex flex-row items-center gap-1">
  <mat-icon matTooltip="Prior expert" (click)="navigateBack()">
    chevron_left
  </mat-icon>
  <span>
    <b>{{ selectedRespondent.firstName }} {{ selectedRespondent.lastName }}</b>
    | {{ selectedRespondent.geography }} - {{ selectedRespondent.segment }} |
    {{ selectedRespondent.callDate | date: 'd MMM y, h:mm a' }}
  </span>
  <mat-icon matTooltip="Next expert" (click)="navigateForward()">
    chevron_right
  </mat-icon>
</div>

<mat-dialog-content>
  @if (loading) {
    <app-loader></app-loader>
  } @else {
    <mat-tab-group>
      <mat-tab label="Response grid" class="h-full">
        <div class="flex flex-row h-full">
          <div class="answers-container flex flex-col flex-[50%] gap-4">
            @for (group of groupedThemes; track group) {
              <div class="flex flex-col gap-4">
                <u class="theme">{{ group.theme }}</u>
                @for (question of group.questions; track question) {
                  <div class="flex flex-col gap-4">
                    <b>{{ question.question }}</b>
                    <mat-form-field>
                      <textarea
                        matInput
                        [value]="
                          selectedRespondent.answers[question.question_id]
                            ?.answer || ''
                        "
                        [disabled]="
                          !selectedRespondent.answers[question.question_id]
                        "
                        (keyup)="
                          answerModification(
                            selectedRespondent.answers[question.question_id],
                            $event
                          )
                        "
                      ></textarea>
                    </mat-form-field>
                    <div class="flex flex-wrap gap-2">
                      @for (
                        citation of selectedRespondent.answers[
                          question.question_id
                        ]?.citation || [];
                        track citation;
                        let i = $index
                      ) {
                        <span
                          class="citation"
                          matTooltip="View reference"
                          (click)="navigateCitation(citation)"
                        >
                          Reference {{ i + 1 }}
                        </span>
                      }
                    </div>
                  </div>
                }
              </div>
            }
          </div>
          <div
            class="transcription-container flex-[50%] h-full flex-grow items-center content-center overflow-auto"
          >
            @if (!transcriptFile) {
              <div class="progress">Transcription in progress</div>
            } @else {
              <app-transcription-playback
                [transcriptChunks]="transcriptChunks"
                [audioData]="audioData"
                [fileName]="transcriptFileName"
                [audioStartTime]="audioStartTime"
              ></app-transcription-playback>
            }
          </div>
        </div>
      </mat-tab>
      @if (selectedRespondent.transcriptSummary) {
        <mat-tab label="Call summary">
          <div style="padding: 16px">
            <app-echo
              [fileKey]="selectedRespondent.transcriptSummary.fileKey"
            ></app-echo>
          </div>
        </mat-tab>
      }
      @if (respondentId) {
        <mat-tab label="Saved quotes">
          <div style="padding: 16px">
            <app-expert-quotes [expertId]="respondentId"></app-expert-quotes>
          </div>
        </mat-tab>
      }
      <mat-tab label="Expert files">
        <div style="padding: 16px">
          <app-expert-files
            [files]="selectedRespondent.files"
          ></app-expert-files>
        </div>
      </mat-tab>
    </mat-tab-group>
  }
</mat-dialog-content>

<mat-dialog-actions class="flex gap-2">
  <button
    class="flex-1 primaryColor-border"
    mat-stroked-button
    mat-dialog-close
  >
    Close window
  </button>
  <button class="flex-1" mat-flat-button color="primary" (click)="confirm()">
    Confirm
  </button>
</mat-dialog-actions>
